import React from 'react';
var Menu = require('../ui_elements/menu').Menu;
var MenuList = require('../ui_elements/menu-list');
import { VstInput } from 'vstui';
import { Select } from "@vitalsource/vstui";

// Renders the Force Update Password Container
class ForceUpdateContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPassword: "", currentPasswordFailure: false,
      newPassword: "", newPasswordFailure: false,
      newPasswordConfirmation: "", newPasswordConfirmationFailure: false,
      questionResponse: "", questionResponseFailure: false,
      questionId: 6
    };

    // Bind callback methods
    this._updateInput = this._updateInput.bind(this);
    this._updatePassword = this._updatePassword.bind(this);
    this._validateQuestionResponse = this._validateQuestionResponse.bind(this);
    this._validateCurrentPassword = this._validateCurrentPassword.bind(this);
    this._validateNewPassword = this._validateNewPassword.bind(this);
    this._validateNewPasswordConfirmation = this._validateNewPasswordConfirmation.bind(this);

    this.pwdConfirmInputRef = React.createRef();
  }

  componentDidUpdate(){
    $("#login-return").val(document.location.protocol+"//"+document.location.host);
    // TODO :: Maybe we can bring this up a level?
    Fraction.Helpers.bindLinks();
  }

  _validateNewPassword(){
    if (!Fraction.Helpers.Users.isValidPassword(this.state.newPassword)){
      this.setState({newPasswordFailure: i18n.t('registration.valid-password')});
      return false;
    }
    this.setState({newPasswordFailure: false});
    return true;
  }

  _validateNewPasswordConfirmation(){
    if (this.state.newPassword!==this.state.newPasswordConfirmation){
      if (this._validateNewPassword() && this._validateInputExistence("newPasswordConfirmationFailure", this.state.newPasswordConfirmation)){
        this.setState({newPasswordConfirmationFailure: i18n.t('registration.pwd-no-match')});
      }
      return false;
    }
    this.setState({newPasswordConfirmationFailure: false});
    return true;
  }

  _validateInputExistence(errorKey, value){
    if (value.length === 0){
      const newState = {};
      newState[errorKey] = i18n.t('registration.please-fill-out');
      this.setState(newState);
      return false;
    }
    return true;
  }

  _validateCurrentPassword(e){
    return !Fraction.Brand.Password.requireCurrentPassword || this._validateInputExistence("currentPasswordFailure", this.state.currentPassword);
  }

  _validateQuestionResponse(e){
    return this._validateInputExistence("questionResponseFailure", this.state.questionResponse);
  }

  _isSumittable(){
    const currentPassword = this._validateCurrentPassword();
    const questionResponse = this._validateQuestionResponse();
    const newPassword = this._validateNewPassword();
    const newPasswordConfirmation = this._validateNewPasswordConfirmation();
    return (currentPassword && questionResponse && newPassword && newPasswordConfirmation);
  }

  _updateInput(e){
    var input = $(e.currentTarget);
    var o = {};
    if (input.attr("type")==="checkbox"){
      o[input.data('key')] = input.is(":checked");
    } else {
      o[input.data('key')] = input.val();
    }
    o[`${input.data('key')}Failure`] = false;
    this.setState(o);
  }

  _updatePassword(e){
    e.preventDefault();
    if (this._isSumittable()){
      Fraction.Helpers.getUser(() => {
        Fraction.Helpers.setUserInfo({currentPassword: this.state.currentPassword,
                             questionResponse: this.state.questionResponse,
                             questionId: this.state.questionId,
                             password: this.state.newPassword,
                             passwordConfirmation: this.state.newPasswordConfirmation}, (response) => {
          if (response.isSuccess()){
            Fraction.Helpers.redirectMe();
          } else {
            if (response.data.errors && response.data.errors.password &&
                response.data.errors.password[0].match(/same|previous/i)){
              this.setState({newPasswordFailure: i18n.t('update-password.cannot-be-the-same')});
            } else {
              this.setState({newPasswordFailure: i18n.t('update-password.current-incorrect')});
            }
          }
        });
      });
    }
  }

  render(){
    var redirect="";
    var failure="";

    return (
      <div>

        <div onScroll={this.props.redraw}>
          { Fraction.Helpers.modalToShow }

          <div className="account">

            {this.props.renderAccountGraphic("register")}

            <div className="account-content registration">

              <div className={"step register-form"}>
                <h1 className="large">
                  {i18n.t('update-password.please-update')}
                </h1>
                <h1 className="small">
                  {i18n.t('update-password.please-update')}
                </h1>

                <span>{i18n.t('update-password.update-messaging')}</span>

                <form method="post" id="registration-form" onSubmit={this._updatePassword} noValidate>
                  <Select
                    required
                    label={i18n.t('update-password.new-security-question')}
                    id="security-question-input"
                    className="security-question"
                    name="user[security-question]"
                    onChange={this._updateInput}
                    data-key="questionId"
                    value={this.state.questionId}
                    fullWidth
                  >
                    <option value={6}>{i18n.t('registration.security-question6')}</option>
                    <option value={7}>{i18n.t('registration.security-question7')}</option>
                    <option value={8}>{i18n.t('registration.security-question8')}</option>
                    <option value={9}>{i18n.t('registration.security-question9')}</option>
                    <option value={10}>{i18n.t('registration.security-question10')}</option>
                  </Select>
                  <VstInput required
                            label={i18n.t('registration.security-answer')}
                            failure={this.state.questionResponseFailure}
                            id="security-answer-input"
                            type="text"
                            options="medium"
                            name="user[security-answer]"
                            data-key="questionResponse"
                            onChange={this._updateInput}
                            onBlur={this._validateQuestionResponse}
                            value={this.state.questionResponse} />
                  {Fraction.Brand.Password.requireCurrentPassword &&
                    <VstInput required
                              label={i18n.t('update-password.current-password')}
                              id="current-password-input"
                              failure={this.state.currentPasswordFailure}
                              type="password"
                              name="user[current-password]"
                              data-key="currentPassword"
                              onChange={this._updateInput}
                              onBlur={this._validateCurrentPassword}
                              value={this.state.currentPassword} />
                  }
                  <div className="duplex">
                    <VstInput required
                              label={i18n.t('base.password')}
                              id="password-input-small"
                              type="password"
                              className="password-input"
                              failure={this.state.newPasswordFailure}
                              name="user[password]"
                              data-key="newPassword"
                              onBlur={this._validateNewPassword}
                              onChange={this._updateInput}
                              value={this.state.newPassword} />
                    <VstInput required
                              label={i18n.t('base.confirm-password')}
                              id="password-confirm-input-small"
                              ref={this.pwdConfirmInputRef}
                              type="password"
                              failure={this.state.newPasswordConfirmationFailure}
                              name="user[confirm-password]"
                              data-key="newPasswordConfirmation"
                              onBlur={this._validateNewPasswordConfirmation}
                              onChange={this._updateInput}
                              value={this.state.newPasswordConfirmation} />
                  </div>

                  <input type="hidden" name="return" id="login-return" value={redirect} />
                  <input type="hidden" name="failure" id="login-return" value={failure} />

                  <VstInput type="submit"
                            options="btn-44 block"
                            className="registration-create inactive"
                            value={i18n.t('base.submit')} />
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }

}

module.exports = ForceUpdateContainer;
